// Substitute shades in the PDP shade grid. Two pairs share this module: Life
// Color Plus -> 3Deluxe, and (2026-09) new Majirel 60ml -> old Majirel 50ml.
// Brand/size copy comes from data.sourceBrand / data.brand / data.targetSize
// (read off #shade-swap-data) rather than being hardcoded, so this file does
// not need editing to add a third pair -- only bulk-shade-modal.liquid does.
//
// Reads the SAME #shade-swap-data the bulk modal uses, so the two can never
// disagree about which shades are rescuable.
//
// The swatch radio stays DISABLED throughout. See docs/superpowers/specs/
// 2026-08-11-pdp-substitute-shade-grid-design.md, "Why the radio stays disabled".
(function () {
  'use strict';

  var data = null;
  var subs = [];

  // Pure logic, mirrored verbatim in tests/pdp-shade-substitute-copy.mjs — see
  // that file's own header comment for why the two must stay in step. Centralises
  // the pair's display copy so no fallback string is typed out twice.
  function substituteCopy(data) {
    return {
      sourceBrand: (data && data.sourceBrand) || 'Life Color Plus',
      targetBrand: (data && data.brandShort) || '3Deluxe',
      targetBrandFull: (data && data.brand) || '3Deluxe Professional',
      targetSize: (data && data.targetSize) || '100ml',
    };
  }

  function readData() {
    var el = document.getElementById('shade-swap-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // Undo everything markSwatches() applies. Without this a re-read after
  // product:updated leaves a swatch whose twin has since sold out still glowing,
  // focusable and no longer struck through, while findSub() returns null so
  // clicking it does nothing -- a dead swatch that does not look sold out.
  function unmarkSwatches() {
    var marked = document.querySelectorAll('.swatchLbl--sub');
    for (var i = 0; i < marked.length; i++) {
      var l = marked[i];
      l.classList.remove('swatchLbl--sub', 'is-selected');
      l.classList.add('unavailable');
      l.removeAttribute('tabindex');
      l.removeAttribute('role');
      l.removeAttribute('aria-label');
      l.removeAttribute('data-sub-tip');
      l.removeAttribute('data-sub-shade');
    }
  }

  function markSwatches() {
    unmarkSwatches();
    subs = [];
    var inputs = document.querySelectorAll('.swatchInput.color');

    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      // Only sold-out swatches are candidates. An in-stock shade needs no substitute.
      if (!input.disabled) continue;

      var shade = input.value;
      var pair = data.pairs[shade];
      // A nil target_variant in variant-picker.liquid still renders a disabled
      // input, but with an empty data-variant-id. Marking it would post
      // properties[_substitute_for]="" -- Shopify drops the blank, no held price
      // is applied, and the shopper pays £5.49 after being promised £3.49.
      var lcpId = input.getAttribute('data-variant-id') || '';
      if (!pair || !pair.id || !/^\d+$/.test(lcpId)) continue;

      var label = document.querySelector('label[for="' + input.id + '"]');
      if (!label) continue;

      label.classList.remove('unavailable');
      label.classList.add('swatchLbl--sub');
      label.setAttribute('tabindex', '0');
      label.setAttribute('role', 'button');
      var copy = substituteCopy(data);
      label.setAttribute('aria-label',
        shade + ' is out of stock in ' + copy.sourceBrand + '. Choose the identical ' + copy.targetBrand
        + ' ' + shade + ' instead, at the same price.');
      label.setAttribute('data-sub-tip', 'Out of stock — get the same shade in ' + copy.targetBrand + ', same price');
      label.setAttribute('data-sub-shade', shade);

      subs.push({
        shade: shade,
        lcpVariantId: lcpId,
        lcpSku: input.getAttribute('data-lcp-sku') || '',
        delVariantId: String(pair.id),
        delSku: pair.sku || '',
        qty: pair.qty || 0
      });
    }

    window.__pdpSub.subCount = subs.length;
    window.__pdpSub.subs = subs;
  }

  // ── Selecting a substitute ────────────────────────────────────────────
  //
  // The radio stays disabled and the click is prevented, so Shopify's variant
  // machinery never runs and never selects the sold-out Life Color Plus variant.
  // Instead the product form is driven directly: swap [name=id] to the 3Deluxe
  // variant and add the two line properties. theme.js's own submit handler then
  // adds the right line and opens the Added-to-basket panel with no help from us.

  var PROP_FOR = 'properties[_substitute_for]';
  var PROP_SKU = 'properties[_substitute_for_sku]';
  var PROP_NAME = 'properties[_substitute_for_name]';
  var selected = null;
  var originalVariantId = null;
  var activeDelVariantId = null;
  var originalQtyMax = null;

  // The MAIN product form, scoped to <product-form>. Resolving by a global
  // button[name="add"] is not safe: the theme renders that name in product cards,
  // quick-shop, the product popup and the cart drawer's gift block, and it only
  // happens to pick the right one because of current render order. Shopify's
  // installment form is also a /cart/add form -- it lives outside <product-form>,
  // so scoping this way excludes it without matching on a class it doesn't have.
  function productForm() {
    var f = document.querySelector('product-form form[action*="/cart/add"]');
    if (f) return f;
    var btn = document.querySelector('product-form button[name="add"]');
    return btn ? btn.form : null;
  }

  function addButton() {
    var f = productForm();
    return f ? f.querySelector('button[name="add"], [type="submit"]') : null;
  }

  // Arriving at ?variant=<sold-out shade> renders the Add to Cart wrapper hidden
  // and the button disabled. Without this the shopper following a back-in-stock
  // email or a Shopping feed link -- the feature's flagship case -- gets the full
  // "Same shade, in stock now" reveal and no way to buy it.
  function setBuyableForSubstitute(on) {
    // The wrapper is rendered as AddToCartWrapper-{{ section.id }} -- a bare
    // getElementById('AddToCartWrapper') matched nothing on any page, so this
    // whole rescue was dead code and the sold-out deep link (a back-in-stock
    // email or a feed URL, the feature's flagship entry path) dead-ended with
    // the reveal shown and no Add to Cart button.
    var wrap = document.querySelector('[id^="AddToCartWrapper"]');
    if (wrap) {
      if (on) {
        if (wrap.classList.contains('hide')) {
          wrap.classList.remove('hide');
          wrap.setAttribute('data-pdp-sub-unhid', '');
        }
        if (wrap.style.display === 'none' || wrap.style.display === '') {
          // The theme sets display:flex when it un-hides this, not '' -- see
          // its own handler in sections/product-template.liquid.
          wrap.style.display = 'flex';
          wrap.setAttribute('data-pdp-sub-unset-display', '');
        }
      } else {
        if (wrap.hasAttribute('data-pdp-sub-unhid')) {
          wrap.classList.add('hide');
          wrap.removeAttribute('data-pdp-sub-unhid');
        }
        if (wrap.hasAttribute('data-pdp-sub-unset-display')) {
          wrap.style.display = 'none';
          wrap.removeAttribute('data-pdp-sub-unset-display');
        }
      }
    }

    var btn = addButton();
    if (!btn) return;
    var txt = btn.querySelector('.txt');
    if (on) {
      if (btn.disabled) {
        btn.disabled = false;
        btn.setAttribute('data-pdp-sub-enabled', '');
      }
      btn.removeAttribute('aria-disabled');
      // Without this the button reads "Sold out" while offering an in-stock
      // product -- the developer module already relabels; this one did not.
      if (txt && !btn.hasAttribute('data-pdp-sub-label')) {
        btn.setAttribute('data-pdp-sub-label', txt.textContent);
        txt.textContent = 'Add to cart';
      }
    } else if (btn.hasAttribute('data-pdp-sub-enabled')) {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      if (txt && btn.hasAttribute('data-pdp-sub-label')) {
        txt.textContent = btn.getAttribute('data-pdp-sub-label');
      }
      btn.removeAttribute('data-pdp-sub-label');
      btn.removeAttribute('data-pdp-sub-enabled');
    }
  }

  // The "Shade: X" readout next to the grid. variant-picker.liquid keeps this in
  // sync on the radio's change event, which never fires for a substitute.
  function setShadeLabel(text) {
    var el = document.querySelector('.product-form__input.swatch [data-opt]');
    if (el) el.textContent = text;
  }

  function findSub(shade) {
    for (var i = 0; i < subs.length; i++) {
      if (subs[i].shade === shade) return subs[i];
    }
    return null;
  }

  function setHidden(form, name, value) {
    var el = form.querySelector('input[name="' + name + '"][data-pdp-sub]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = name;
      el.setAttribute('data-pdp-sub', '');
      form.appendChild(el);
    }
    el.value = value;
  }

  // The facts copy has exactly ONE literal source: the rendered
  // .shade-swap-why from snippets/bulk-shade-modal-swap-facts.liquid. Both this
  // module and the modal's rebuild path read that node. There is deliberately no
  // fallback string here -- a second copy would mean the unverified
  // "1:1.5 mix ratio" claim needs correcting in more than one place. If the node
  // is absent the reveal simply ships without the facts line.
  function factsNode() {
    var src = document.querySelector('.shade-swap-why');
    return src ? src.cloneNode(true) : null;
  }

  // ── Tube view ─────────────────────────────────────────────────────────
  //
  // Every shade on this product shows the branded tube with its shade as a
  // small swatch beside it, replacing the carousel of near-identical squares.
  // Substitutes show the 3Deluxe tube; everything else shows this product's own.

  var tube = null;

  function readTubeData() {
    var el = document.getElementById('pdp-shade-tube-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // Shopify CDN URLs take the size as a query param, so a bigger derivative of
  // an image we already have costs nothing to ask for. The modal's pairs carry
  // width=100 thumbnails, far too small for the popout.
  function atWidth(url, w) {
    if (!url) return url;
    return /([?&])width=\d+/.test(url)
      ? url.replace(/([?&])width=\d+/, '$1width=' + w)
      : url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function currentShade() {
    if (selected) return selected;
    var chk = document.querySelector('.swatchInput.color:checked');
    return chk ? chk.value : null;
  }

  // Tube + swatch for a shade. Substitutes borrow the 3Deluxe side.
  function tubeViewFor(shade) {
    var sub = findSub(shade);
    if (sub && data && data.packshot) {
      var pair = data.pairs[shade];
      return { packshot: data.packshot,
               swatch: pair ? atWidth(pair.image, 600) : null,
               brand: data.brandShort || '3Deluxe' };
    }
    if (!tube || !tube.sourcePackshot) return null;
    return { packshot: tube.sourcePackshot,
             swatch: (tube.shades || {})[shade] || null,
             brand: (tube && tube.sourceBrand) || substituteCopy(data).sourceBrand };
  }

  // If the tube cannot be built for any reason, drop the boot class so the
  // original gallery becomes visible again. Hiding it before first paint is
  // only safe if every failure path puts it back -- otherwise a missing
  // packshot or an unexpected DOM leaves a product page with no image at all.
  function abandonTubeView() {
    document.documentElement.classList.remove('pdp-sub-boot');
    var slider = document.querySelector('.primgSlider[data-pdp-sub-hidden]');
    if (slider) { slider.style.visibility = ''; slider.removeAttribute('data-pdp-sub-hidden'); }
    // Tear down ALL of it. Removing only the boot class restored the slider
    // underneath a stale absolutely-positioned packshot, and left the thumbnail
    // strip hidden by the surviving .pdp-sub-gallery rule.
    var shot = document.getElementById('pdp-sub-packshot');
    if (shot && shot.parentNode) shot.parentNode.removeChild(shot);
    var gal = document.querySelector('media-gallery.pdp-sub-gallery');
    if (gal) gal.classList.remove('pdp-sub-gallery');
    var host = document.querySelector('.pr_lg_img.pdp-sub-host');
    if (host) host.classList.remove('pdp-sub-host');
  }

  function renderTubeView() {
    var shade = currentShade();
    var view = shade ? tubeViewFor(shade) : null;
    var host = galleryHost();
    if (!shade || !view || !view.packshot || !host) { abandonTubeView(); return; }

    var slider = host.querySelector('.primgSlider');
    if (slider && !slider.hasAttribute('data-pdp-sub-hidden')) {
      slider.style.visibility = 'hidden';
      slider.setAttribute('data-pdp-sub-hidden', '');
    }
    host.classList.add('pdp-sub-host');

    // Flag the gallery so the thumbnail strip can be hidden. .thumbs_nav is a
    // SIBLING of .pr_lg_img, so it cannot be reached from the host alone -- and
    // the strip is a column of shade squares, which is exactly the presentation
    // the tube view replaces.
    var gallery = host.closest('media-gallery');
    if (gallery) gallery.classList.add('pdp-sub-gallery');

    var shot = document.getElementById('pdp-sub-packshot');
    if (!shot) {
      shot = document.createElement('div');
      shot.id = 'pdp-sub-packshot';
      shot.className = 'pdp-sub-shot';
      shot.innerHTML = '<img class="pdp-sub-shot__tube" alt="">'
        + '<button type="button" class="pdp-sub-swatch" aria-haspopup="dialog">'
        + '<span class="pdp-sub-swatch__label"></span></button>';
      host.appendChild(shot);
    }

    var tubeImg = shot.querySelector('.pdp-sub-shot__tube');
    if (tubeImg.getAttribute('src') !== view.packshot) tubeImg.src = view.packshot;
    tubeImg.alt = view.brand + ' ' + shade;

    // The badge keeps the shade NUMBER as its subject -- that is what a
    // colourist reads -- but it is painted in the shade's OWN colour rather
    // than left as a flat dark box. Every LCP shade shares one tube photo, so
    // with a uniform badge the entire image changed nothing at all between
    // shades except two digits: "the shade at the bottom right doesnt change
    // when i choose a different shade". It now does.
    var btn = shot.querySelector('.pdp-sub-swatch');
    btn.querySelector('.pdp-sub-swatch__label').textContent = shade;
    btn.setAttribute('data-shade', shade);
    if (view.swatch) {
      btn.hidden = false;
      btn.setAttribute('aria-label', 'View shade ' + shade + ' full size');
      btn.setAttribute('data-full', view.swatch);
      paintBadge(btn, shade, view.swatch);
    } else {
      // No swatch image, but the shade still belongs on the tube -- fall back
      // to the plain dark badge rather than dropping the number.
      btn.hidden = false;
      btn.removeAttribute('data-full');
      btn.setAttribute('aria-label', 'Shade ' + shade);
      resetBadge(btn);
    }
  }

  // ── Badge colour ──────────────────────────────────────────────────────
  //
  // Every Life Color Plus shade shares ONE tube photograph, so with a flat dark
  // badge the whole image was identical from shade to shade and only two digits
  // moved: "the shade at the bottom right doesnt change when i choose a
  // different shade". The badge now carries the shade's own colour.
  //
  // It carries the shade's TEXTURE as well as its colour -- "it needs to have
  // the shade texture as the image and overlay the colour" -- so the badge
  // reads as a piece of that shade's hair rather than as a flat paint chip.
  //
  // WHY THIS IS NOT JUST `background-image: url(swatch)`.
  //
  // These swatch images will not survive a naive crop. Two things are in the
  // way, and both were seen on the live page before this was written:
  //
  //   1. The shade NUMBER is burned into the middle of the image at enormous
  //      size -- open the popout and "6.12" fills the whole swatch. Any centred
  //      crop shows a slice of a white digit stroke lying across the badge.
  //   2. The Life Color Plus swatches are a DISC on white (measured: the disc
  //      spans 10%-90% of a square image), so a crop that avoids the digits by
  //      moving outward hits the white surround instead. `cover` showed a white
  //      wedge; multiply turned the surround into a pale frame around a dark
  //      oval.
  //
  // A fixed crop cannot satisfy both, because the digits are a different width
  // on every shade -- "4.0" and "12.021" do not occupy the same box. So the
  // clean region is FOUND rather than assumed: the image is scanned for the
  // window with the fewest near-white pixels, and that window alone is cut out
  // and used as the texture. It handles the round Life Color Plus swatches and
  // the square 3Deluxe ones a substitute borrows, without knowing which it has.
  //
  // The shape, size and position of the badge are unchanged -- deliberately.
  // They are the ones the merchant asked to keep.

  var badgeTextures = {};

  /** Relative luminance, 0..1. */
  function luminance(rgb) {
    return (0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]) / 255;
  }

  /** Analysis grid, and the window cut from it. Both in grid units. */
  var SWATCH_GRID = 64;
  var SWATCH_WINDOW = 16;
  /** Above this share of near-white pixels, no window is clean enough to use. */
  var SWATCH_MAX_WHITE = 0.12;

  /**
   * Finds the cleanest patch of a swatch image and returns it as a texture.
   *
   * Calls back with `{ url, rgb }` -- a data: URL of the patch, and its mean
   * colour -- or with null on any failure: a broken image, or a canvas the
   * browser considers tainted, or a swatch with no patch clear of the burned-in
   * number. The badge then stays exactly as it was before this existed.
   */
  function swatchTexture(url, cb) {
    if (badgeTextures[url] !== undefined) { cb(badgeTextures[url]); return; }

    var img = new Image();
    // Shopify's CDN sends Access-Control-Allow-Origin, so the pixels are
    // readable. Without this attribute the canvas is tainted and getImageData
    // throws -- caught below, and the badge simply stays dark.
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      var out = null;
      try {
        out = cutCleanestPatch(img);
      } catch (e) {
        out = null;
      }
      badgeTextures[url] = out;
      cb(out);
    };
    img.onerror = function () { badgeTextures[url] = null; cb(null); };
    // Big enough that the cut patch still has real detail in it once magnified
    // into the badge; far smaller than the 600px copy the popout wants.
    img.src = atWidth(url, 400);
  }

  function cutCleanestPatch(img) {
    var N = SWATCH_GRID;
    var W = SWATCH_WINDOW;
    var canvas = document.createElement('canvas');
    canvas.width = N;
    canvas.height = N;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, N, N);
    var d = ctx.getImageData(0, 0, N, N).data;

    var best = null;
    // The 4px inset keeps the window off the very edge, which on these images
    // is always mount rather than hair.
    for (var oy = 4; oy <= N - W - 4; oy += 2) {
      for (var ox = 4; ox <= N - W - 4; ox += 2) {
        var white = 0, r = 0, g = 0, b = 0, k = 0;
        for (var j = oy; j < oy + W; j++) {
          for (var i = ox; i < ox + W; i++) {
            var p = (j * N + i) * 4;
            var L = 0.2126 * d[p] + 0.7152 * d[p + 1] + 0.0722 * d[p + 2];
            // Transparent counts as white: a PNG swatch may be cut out rather
            // than mounted on a white square, and either way it is not hair.
            if (d[p + 3] < 200 || L > 232) { white++; }
            else { r += d[p]; g += d[p + 1]; b += d[p + 2]; k++; }
          }
        }
        var frac = white / (W * W);
        var dist = Math.sqrt(
          Math.pow(ox + W / 2 - N / 2, 2) + Math.pow(oy + W / 2 - N / 2, 2)
        ) / N;
        // Cleanliness dominates; distance from the middle only breaks ties, so
        // of two equally clean patches the more central one wins.
        var score = frac * 10 + dist;
        if (!best || score < best.score) {
          best = {
            score: score, frac: frac, ox: ox, oy: oy,
            rgb: k ? [Math.round(r / k), Math.round(g / k), Math.round(b / k)] : null
          };
        }
      }
    }
    if (!best || !best.rgb || best.frac > SWATCH_MAX_WHITE) return null;

    // Re-cut at the image's own resolution rather than upscaling the 64px
    // analysis copy, so the strands stay strands.
    var scale = img.naturalWidth / N;
    var out = document.createElement('canvas');
    out.width = 64;
    out.height = 64;
    out.getContext('2d').drawImage(
      img, best.ox * scale, best.oy * scale, W * scale, W * scale, 0, 0, 64, 64
    );
    return { url: out.toDataURL('image/jpeg', 0.82), rgb: best.rgb };
  }

  function resetBadge(btn) {
    btn.style.backgroundColor = '';
    btn.style.backgroundImage = '';
    btn.classList.remove('pdp-sub-swatch--tinted', 'pdp-sub-swatch--light');
  }

  function paintBadge(btn, shade, swatchUrl) {
    swatchTexture(swatchUrl, function (patch) {
      // The shopper can change shade while the image is still loading. Without
      // this the badge would settle on the texture of a shade they have already
      // moved off -- the exact staleness this change exists to fix.
      if (btn.getAttribute('data-shade') !== shade) return;
      if (!patch) { resetBadge(btn); return; }
      // The patch is a data: URL this function built, so there is nothing to
      // escape and nothing that could break out of the url() token.
      btn.style.backgroundImage = 'url("' + patch.url + '")';
      // background-blend-mode: luminosity (in the stylesheet) takes the shading
      // from the patch on top and the hue from this colour underneath, so a
      // slightly off-white or shadowed patch still reads as the right shade.
      btn.style.backgroundColor = 'rgb(' + patch.rgb.join(',') + ')';
      btn.classList.add('pdp-sub-swatch--tinted');
      // Marks a pale swatch so the stylesheet can give the label a heavier
      // shadow. The label stays WHITE on every shade -- this only controls how
      // hard it is shadowed, never its colour, and never the badge's own.
      btn.classList.toggle('pdp-sub-swatch--light', luminance(patch.rgb) > 0.5);
    });
  }

  // ── Shade popout ──────────────────────────────────────────────────────
  function openShadePopout(shade, src) {
    closeShadePopout();
    var ov = document.createElement('div');
    ov.id = 'pdp-sub-popout';
    ov.className = 'pdp-sub-popout';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-label', 'Shade ' + shade);
    ov.innerHTML = '<div class="pdp-sub-popout__box">'
      + '<button type="button" class="pdp-sub-popout__close" aria-label="Close">&times;</button>'
      + '<img alt="Shade ' + shade + '">'
      + '<p class="pdp-sub-popout__shade"></p></div>';
    ov.querySelector('img').src = atWidth(src, 900);
    ov.querySelector('.pdp-sub-popout__shade').textContent = 'Shade ' + shade;
    document.body.appendChild(ov);
    document.body.style.overflow = 'hidden';
    var close = ov.querySelector('.pdp-sub-popout__close');
    close.focus();
    ov.addEventListener('click', function (e) {
      if (e.target === ov || e.target === close) closeShadePopout();
    });
  }

  function closeShadePopout() {
    var ov = document.getElementById('pdp-sub-popout');
    if (ov && ov.parentNode) ov.parentNode.removeChild(ov);
    document.body.style.overflow = '';
  }

  // media-gallery-group.liquid renders one group per colour, inactive ones
  // carrying .hide. Taking the first .pr_lg_img can land on a hidden group, so
  // the packshot would be inserted invisibly while the real image stayed put.
  function galleryHost() {
    return document.querySelector('media-gallery-group:not(.hide) .pr_lg_img')
        || document.querySelector('.pr_lg_img');
  }

  function showReveal(sub) {
    hideReveal();

    var form = productForm();
    var btn = addButton();
    if (!form || !btn) return;

    var box = document.createElement('div');
    box.id = 'pdp-sub-reveal';
    box.className = 'pdp-sub-reveal';
    box.setAttribute('role', 'status');
    box.innerHTML =
      '<p class="pdp-sub-reveal__head"><span class="pdp-sub-reveal__tick" aria-hidden="true">&#10003;</span> Same shade, in stock now</p>'
      + '<p class="pdp-sub-reveal__body"><strong></strong> — standing in for <span class="pdp-sub-reveal__was-brand"></span> <span></span>, at the same price</p>';
    var copy = substituteCopy(data);
    box.querySelector('strong').textContent = copy.targetBrandFull + ' ' + copy.targetSize;
    box.querySelector('.pdp-sub-reveal__was-brand').textContent = copy.sourceBrand;
    box.querySelector('.pdp-sub-reveal__body span:last-child').textContent = sub.shade;
    var facts = factsNode();
    if (facts) box.appendChild(facts);

    // Sit directly above the quantity/Add to Cart row.
    var anchor = btn.parentNode === form ? btn : (btn.parentNode || btn);
    anchor.parentNode.insertBefore(box, anchor);

    // The gallery itself is owned by renderTubeView(): it shows the tube for
    // whatever shade is current, substitute or not. showReveal only adds the
    // copy panel.
    renderTubeView();
  }

  function hideReveal() {
    var r = document.getElementById('pdp-sub-reveal');
    if (r && r.parentNode) r.parentNode.removeChild(r);
    // Deliberately does NOT dismantle the tube view. The gallery shows a tube
    // for every shade now, not just substitutes, so tearing it down here would
    // flip the page back to the carousel on revert -- and reinstating it is
    // exactly the add/remove churn that caused the layout shift.
    renderTubeView();
  }

  function selectSubstitute(shade) {
    var form = productForm();
    var sub = findSub(shade);
    if (!form || !sub) return;

    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    if (originalVariantId === null) originalVariantId = idInput.value;

    idInput.value = sub.delVariantId;
    activeDelVariantId = sub.delVariantId;
    setHidden(form, PROP_FOR, sub.lcpVariantId);
    setHidden(form, PROP_SKU, sub.lcpSku);
    setHidden(form, PROP_NAME, substituteCopy(data).sourceBrand + ' ' + sub.shade);

    var qty = form.querySelector('[name="quantity"]');
    if (qty) {
      if (originalQtyMax === null) originalQtyMax = qty.getAttribute('max') || '';
      qty.setAttribute('max', String(sub.qty));
      if (parseInt(qty.value, 10) > sub.qty) qty.value = String(sub.qty);
    }

    var prev = document.querySelector('.swatchLbl--sub.is-selected');
    if (prev) prev.classList.remove('is-selected');
    var lbl = document.querySelector('.swatchLbl--sub[data-sub-shade="' + shade + '"]');
    if (lbl) lbl.classList.add('is-selected');

    // The radio cannot be checked (that would let Shopify select the sold-out
    // variant), so the two things the theme drives off :checked have to be
    // updated by hand, or the page says "Shade: 1.0" with the old swatch still
    // outlined while showing a 3Deluxe 4.1 packshot.
    setShadeLabel(shade);
    var fieldset = lbl ? lbl.closest('.product-form__input.swatch') : null;
    if (fieldset) fieldset.setAttribute('data-sub-active', '');

    // Set `selected` BEFORE painting. renderTubeView() resolves the current
    // shade from it, so painting first rendered the previously selected
    // ordinary shade -- the tube never switched to 3Deluxe.
    selected = shade;
    window.__pdpSub.selected = shade;

    setBuyableForSubstitute(true);
    showReveal(sub);
  }

  function clearSubstitute() {
    var form = productForm();
    if (!form) return;

    // Only restore if OUR value is still in place. The theme rewrites [name=id]
    // on its own schedule (product-template defers its write behind a timeout),
    // and jQuery .trigger('change') in theme.js does not reach native document
    // listeners -- so a programmatic re-selection can leave us stale. Writing
    // back unconditionally would then clobber the theme's newer, correct id.
    if (originalVariantId !== null) {
      var idInput = form.querySelector('[name="id"]');
      if (idInput && activeDelVariantId && idInput.value === activeDelVariantId) {
        idInput.value = originalVariantId;
      }
      originalVariantId = null;
      activeDelVariantId = null;
    }

    // Remove by node, never by blanking the value: an empty-valued
    // properties[...] input still posts the key and still tags the line as a
    // substitute, which would hand an ordinary line a price it has not earned.
    var stale = form.querySelectorAll('input[data-pdp-sub]');
    for (var i = 0; i < stale.length; i++) {
      stale[i].parentNode.removeChild(stale[i]);
    }

    var qty = form.querySelector('[name="quantity"]');
    if (qty && originalQtyMax !== null) {
      if (originalQtyMax) qty.setAttribute('max', originalQtyMax);
      else qty.removeAttribute('max');
      originalQtyMax = null;
    }

    var prev = document.querySelector('.swatchLbl--sub.is-selected');
    if (prev) prev.classList.remove('is-selected');

    // Hand the selected look back to the real checked radio.
    var fieldset = document.querySelector('.product-form__input.swatch[data-sub-active]');
    if (fieldset) fieldset.removeAttribute('data-sub-active');
    var checked = document.querySelector('.swatchInput.color:checked');
    if (checked) setShadeLabel(checked.value);

    // Clear BEFORE painting. hideReveal() and renderTubeView() below both
    // resolve the current shade through currentShade(), which returns
    // `selected` first when it is still set -- so clearing after would repaint
    // the substitute tube/badge we're supposed to be leaving, even though the
    // radio, the "Shade:" label and the Add to Cart button had already reverted.
    // That's the mirror image of the ordering note in selectSubstitute() above.
    selected = null;
    window.__pdpSub.selected = null;

    setBuyableForSubstitute(false);
    hideReveal();
    renderTubeView();
  }

  function onActivate(e) {
    if (!e.target || !e.target.closest) return;

    var lbl = e.target.closest('.swatchLbl--sub');
    if (lbl) {
      e.preventDefault();   // the radio must NOT become checked
      selectSubstitute(lbl.getAttribute('data-sub-shade'));
      return;
    }

    // Clicking an ORDINARY swatch must leave substitute mode -- and `change` is
    // not enough on its own. If the shopper picks a substitute and then clicks
    // the shade that was already selected beforehand, that radio is still
    // checked, so no change event fires and the page would stay stuck showing
    // the substitute. Clearing on the click covers it; clearSubstitute is
    // idempotent, so the change listener firing too is harmless.
    if (selected && e.target.closest('.swatchLbl')) clearSubstitute();
  }

  function bind() {
    document.addEventListener('click', onActivate);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var lbl = document.activeElement;
      if (!lbl || !lbl.classList || !lbl.classList.contains('swatchLbl--sub')) return;
      e.preventDefault();
      selectSubstitute(lbl.getAttribute('data-sub-shade'));
    });

    // A real option change means the shopper picked an ordinary shade.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('.swatchInput, .single-option-selector, select')) {
        clearSubstitute();
        renderTubeView();
      }
    });

    // Popout: the small swatch opens the shade full size.
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.pdp-sub-swatch') : null;
      if (!btn) return;
      e.preventDefault();
      var full = btn.getAttribute('data-full');
      if (full) openShadePopout(btn.getAttribute('data-shade'), full);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeShadePopout();
    });

    // Combined-listing switch re-renders the grid: re-read and re-mark.
    document.addEventListener('product:updated', function () {
      clearSubstitute();
      data = readData();
      tube = readTubeData();
      if (data && data.pairs && data.holdPrice) { markSwatches(); }
      else { unmarkSwatches(); subs = []; window.__pdpSub.subs = subs; window.__pdpSub.subCount = 0; }
      renderTubeView();
    });
  }

  function init() {
    data = readData();
    tube = readTubeData();
    // Any early return here means no tube view, so the hidden gallery has to
    // come back before we leave.
    if (!data || !data.pairs) { abandonTubeView(); return; }   // not the Life Color Plus PDP
    if (!data.holdPrice) { abandonTubeView(); return; }        // never advertise a price checkout won't charge
    window.__pdpSub.ready = true;
    window.__pdpSub.pairCount = Object.keys(data.pairs).length;
    markSwatches();
    tube = readTubeData();
    renderTubeView();
    bind();
  }

  window.__pdpSub = { ready: false, pairCount: 0, selected: null };

  // The boot class is set by an inline script that always runs; only this file
  // can remove it. If init() throws, the gallery stays hidden with nothing in
  // its place -- a product page with no image at all. Fail visible instead.
  function safeInit() {
    try { init(); } catch (e) {
      abandonTubeView();
      if (window.console && console.warn) console.warn('PDP substitute init failed; gallery restored', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    safeInit();
  }
})();
